// removed by extract-text-webpack-plugin
module.exports = {"label":"src-scripts-components-StudentCard-StudentDataPanel-__studentDataPanel___label","data":"src-scripts-components-StudentCard-StudentDataPanel-__studentDataPanel___data"};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/StudentCard/StudentDataPanel/studentDataPanel.css
// module id = 630
// module chunks = 0